import type {
  Candidate,
  EmployerEvent,
  EmployerListing,
  RecruitmentCampaign,
} from '../types/employer'

export const employerProfile = {
  name: 'Havazon Works',
  sector: 'Technology · Enterprise software',
  size: '450 employees',
  locations: ['Lagos', 'Abuja', 'Remote — Nigeria'],
  verified: true,
  verifiedOn: '14 Mar 2026',
  about:
    'Enterprise platform group inside the Havazon ecosystem. Recruits engineering, data and product talent from Nigerian universities.',
  recruiter: 'Ada Nwachukwu · Talent partner',
}

export const employerListings: EmployerListing[] = [
  {
    id: 'el-1',
    title: 'Product Analyst Intern',
    kind: 'Internship',
    location: 'Remote — Nigeria',
    workMode: 'Remote',
    compensationLabel: '₦300,000 / month',
    deadlineLabel: 'Closes 3 Sep',
    state: 'Published',
    targetProgrammes: ['Systems Engineering', 'Computer Science', 'Economics'],
    targetLevels: ['300 level', '400 level'],
    requirements: ['SQL', 'Analytics', 'Product sense', 'CGPA 3.0+'],
    applications: 84,
    views: 1420,
  },
  {
    id: 'el-2',
    title: 'Graduate Software Engineer',
    kind: 'Graduate programme',
    location: 'Lagos',
    workMode: 'Hybrid',
    compensationLabel: '₦620,000 / month',
    deadlineLabel: 'Closes 30 Sep',
    state: 'Published',
    targetProgrammes: ['Computer Science', 'Computer Engineering', 'Systems Engineering'],
    targetLevels: ['Final year', 'Graduate'],
    requirements: ['One language to depth', 'Data structures', 'Two-year commitment'],
    applications: 212,
    views: 3980,
  },
  {
    id: 'el-3',
    title: 'Data Engineering Intern',
    kind: 'Internship',
    location: 'Lagos',
    workMode: 'Hybrid',
    compensationLabel: '₦280,000 / month',
    deadlineLabel: 'Closes 12 Oct',
    state: 'Draft',
    targetProgrammes: ['Systems Engineering', 'Statistics'],
    targetLevels: ['400 level'],
    requirements: ['Python', 'SQL', 'Warehouse basics'],
    applications: 0,
    views: 0,
  },
  {
    id: 'el-4',
    title: 'Frontend Engineering Intern',
    kind: 'Internship',
    location: 'Remote — Nigeria',
    workMode: 'Remote',
    compensationLabel: '₦260,000 / month',
    deadlineLabel: 'Closed 30 Jun',
    state: 'Closed',
    targetProgrammes: ['Computer Science'],
    targetLevels: ['300 level', '400 level'],
    requirements: ['React', 'TypeScript', 'Portfolio'],
    applications: 137,
    views: 2610,
  },
]

export const candidates: Candidate[] = [
  {
    id: 'cd-1',
    listingId: 'el-1',
    displayName: 'Amarachi Obi',
    initials: 'AO',
    handle: 'amarachi',
    university: 'University of Lagos',
    programme: 'B.Sc. Systems Engineering',
    level: '400 level',
    stage: 'Interview',
    appliedOn: '2 Aug 2026',
    visibleFields: [
      { label: 'Programme', value: 'B.Sc. Systems Engineering, 400 level' },
      { label: 'Portfolio', value: 'Operations research case studies' },
    ],
    withheldFields: ['Contact details', 'Results transcript'],
    skills: ['Python', 'SQL', 'Linear programming'],
  },
  {
    id: 'cd-2',
    listingId: 'el-1',
    displayName: 'Daniel Uzo',
    initials: 'DU',
    handle: 'danielu',
    university: 'University of Lagos',
    programme: 'B.Sc. Computer Science',
    level: '300 level',
    stage: 'Shortlisted',
    appliedOn: '4 Aug 2026',
    visibleFields: [
      { label: 'Programme', value: 'B.Sc. Computer Science, 300 level' },
      { label: 'Portfolio', value: 'Three shipped frontend projects' },
      { label: 'Contact', value: 'Shared with verified employers' },
    ],
    withheldFields: ['Results transcript'],
    skills: ['React', 'TypeScript', 'Analytics'],
  },
  {
    id: 'cd-3',
    listingId: 'el-2',
    displayName: 'Blessing Ade',
    initials: 'BA',
    handle: 'blessinga',
    university: 'University of Lagos',
    programme: 'B.Eng. Chemical Engineering',
    level: '300 level',
    stage: 'Screening',
    appliedOn: '6 Aug 2026',
    visibleFields: [{ label: 'Programme', value: 'B.Eng. Chemical Engineering, 300 level' }],
    withheldFields: ['Contact details', 'Portfolio', 'Results transcript'],
    skills: ['Python', 'Process modelling'],
  },
  {
    id: 'cd-4',
    listingId: 'el-2',
    displayName: 'Tolu Adeleke',
    initials: 'TA',
    handle: 'tolua',
    university: 'University of Lagos',
    programme: 'B.Eng. Mechanical Engineering',
    level: '400 level',
    stage: 'Offer',
    appliedOn: '28 Jul 2026',
    visibleFields: [
      { label: 'Programme', value: 'B.Eng. Mechanical Engineering, 400 level' },
      { label: 'Contact', value: 'Shared with verified employers' },
    ],
    withheldFields: ['Results transcript'],
    skills: ['CAD', 'Reliability', 'Reporting'],
  },
  {
    id: 'cd-5',
    listingId: 'el-2',
    displayName: 'Chidi Nwosu',
    initials: 'CN',
    handle: 'chidin',
    university: 'Obafemi Awolowo University',
    programme: 'B.Sc. Systems Engineering',
    level: '200 level',
    stage: 'Rejected',
    appliedOn: '30 Jul 2026',
    visibleFields: [{ label: 'Programme', value: 'B.Sc. Systems Engineering, 200 level' }],
    withheldFields: ['Contact details', 'Portfolio'],
    skills: ['Python'],
  },
  {
    id: 'cd-6',
    listingId: 'el-1',
    displayName: 'Grace Nnamdi',
    initials: 'GN',
    handle: 'gracen',
    university: 'University of Lagos',
    programme: 'B.Sc. Economics',
    level: 'Graduate 2024',
    stage: 'Applied',
    appliedOn: '11 Aug 2026',
    visibleFields: [
      { label: 'Programme', value: 'B.Sc. Economics, graduated 2024' },
      { label: 'Contact', value: 'Shared with verified employers' },
    ],
    withheldFields: [],
    skills: ['Analytics', 'SQL', 'Research'],
  },
]

export const campaigns: RecruitmentCampaign[] = [
  {
    id: 'cmp-1',
    name: 'Graduate intake 2027 — Lagos cluster',
    universities: ['University of Lagos', 'Obafemi Awolowo University'],
    startsOn: '1 Aug 2026',
    endsOn: '31 Oct 2026',
    state: 'Live',
    targetHires: 18,
    applications: 296,
    shortlisted: 41,
  },
  {
    id: 'cmp-2',
    name: 'Data internship pipeline — northern universities',
    universities: ['Ahmadu Bello University'],
    startsOn: '15 Sep 2026',
    endsOn: '20 Dec 2026',
    state: 'Planning',
    targetHires: 6,
    applications: 0,
    shortlisted: 0,
  },
]

export const employerEvents: EmployerEvent[] = [
  {
    id: 'ee-1',
    title: 'Havazon Works engineering info session',
    university: 'University of Lagos',
    dateLabel: '22 Aug 2026',
    capacity: 200,
    registered: 168,
    kind: 'Info session',
  },
  {
    id: 'ee-2',
    title: 'Graduate assessment day',
    university: 'University of Lagos',
    dateLabel: '5 Sep 2026',
    capacity: 60,
    registered: 41,
    kind: 'Assessment day',
  },
  {
    id: 'ee-3',
    title: 'Engineering career fair stand',
    university: 'Obafemi Awolowo University',
    dateLabel: '19 Sep 2026',
    capacity: 400,
    registered: 112,
    kind: 'Career fair',
  },
]

export const funnel = [
  { stage: 'Applied', count: 296 },
  { stage: 'Screening', count: 164 },
  { stage: 'Shortlisted', count: 41 },
  { stage: 'Interview', count: 22 },
  { stage: 'Offer', count: 9 },
  { stage: 'Hired', count: 6 },
]

export const sourceUniversities = [
  { name: 'University of Lagos', applications: 148 },
  { name: 'Obafemi Awolowo University', applications: 71 },
  { name: 'Ahmadu Bello University', applications: 44 },
  { name: 'Covenant University', applications: 33 },
]

export const recruitmentMetrics = [
  { label: 'Applications this cycle', value: '296', note: 'Across 2 published listings' },
  { label: 'Median time to shortlist', value: '6 days', note: 'From application to decision' },
  { label: 'Offer acceptance', value: '67%', note: '6 accepted of 9 offers' },
  { label: 'Listing fee', value: '₦0', note: 'Billing gated pending commerce readiness' },
]
